export default __webpack_public_path__ + "static/media/Custom-HUD-Radar (3 Layers).b23b292b.jpg";